// Vehicle compatibility data
const compatibleVehicles = [
  // SUVs and Wagons
  { make: "Toyota", model: "RAV4", category: "SUV", hitch: "50mm" },
  { make: "Mazda", model: "CX-5", category: "SUV", hitch: "50mm" },
  { make: "Subaru", model: "Outback", category: "Wagon", hitch: "50mm" },
  { make: "Subaru", model: "Forester", category: "SUV", hitch: "50mm" },
  { make: "Mitsubishi", model: "Outlander", category: "SUV", hitch: "50mm" },
  { make: "Toyota", model: "Kluger", category: "SUV", hitch: "50mm" },
  { make: "Hyundai", model: "Tucson", category: "SUV", hitch: "50mm" },
  { make: "Kia", model: "Sportage", category: "SUV", hitch: "50mm" },
  
  // Utes
  { make: "Toyota", model: "HiLux", category: "Ute", hitch: "50mm" },
  { make: "Ford", model: "Ranger", category: "Ute", hitch: "50mm" },
  { make: "Isuzu", model: "D-MAX", category: "Ute", hitch: "50mm" },
  { make: "Mitsubishi", model: "Triton", category: "Ute", hitch: "50mm" },
  { make: "Mazda", model: "BT-50", category: "Ute", hitch: "50mm" },
  
  // Large SUVs
  { make: "Toyota", model: "LandCruiser", category: "Large SUV", hitch: "50mm" },
  { make: "Toyota", model: "Prado", category: "Large SUV", hitch: "50mm" },
  { make: "Ford", model: "Everest", category: "Large SUV", hitch: "50mm" },
  { make: "Nissan", model: "Patrol", category: "Large SUV", hitch: "50mm" }
];

// Initialize the compatibility checker
function initCompatibilityChecker() {
  const container = document.getElementById('hitch-compatibility');
  if (!container) return;

  // Create HTML structure
  container.innerHTML = `
    <div class="compatibility-checker">
      <h3>Compatible with 50mm (2") Hitch Receivers</h3>
      <p class="compatibility-subtitle">Check if your vehicle is compatible with our bike rack</p>
      
      <div class="search-box">
        <input 
          type="text" 
          id="vehicle-search" 
          placeholder="Search by make or model (e.g., Toyota, RAV4)..."
          aria-label="Search vehicles"
        />
      </div>

      <div class="filter-buttons">
        <button class="filter-btn active" data-filter="all">All Vehicles</button>
        <button class="filter-btn" data-filter="SUV">SUVs</button>
        <button class="filter-btn" data-filter="Ute">Utes</button>
        <button class="filter-btn" data-filter="Wagon">Wagons</button>
        <button class="filter-btn" data-filter="Large SUV">Large SUVs</button>
      </div>

      <div id="vehicle-list" class="vehicle-list"></div>
      
      <p class="compatibility-note">
        <strong>Note:</strong> Most vehicles can be fitted with aftermarket 50mm hitch receivers. 
        Always verify compatibility for your specific year and model.
      </p>
    </div>
  `;

  // Add styles
  addStyles();

  // Render initial list
  renderVehicleList(compatibleVehicles);

  // Add event listeners
  setupEventListeners();
}

// Render vehicle list
function renderVehicleList(vehicles) {
  const listContainer = document.getElementById('vehicle-list');
  
  if (vehicles.length === 0) {
    listContainer.innerHTML = '<p class="no-results">No vehicles found matching your search.</p>';
    return;
  }

  const html = vehicles.map(vehicle => `
    <div class="vehicle-item">
      <div class="vehicle-info">
        <strong>${vehicle.make} ${vehicle.model}</strong>
        <span class="vehicle-category">${vehicle.category}</span>
      </div>
      <div class="hitch-badge">
        <span class="checkmark">✓</span> ${vehicle.hitch}
      </div>
    </div>
  `).join('');

  listContainer.innerHTML = html;
}

// Setup event listeners
function setupEventListeners() {
  const searchInput = document.getElementById('vehicle-search');
  const filterButtons = document.querySelectorAll('.filter-btn');
  
  let currentFilter = 'all';

  // Search functionality
  searchInput.addEventListener('input', (e) => {
    const searchTerm = e.target.value.toLowerCase();
    filterAndRender(searchTerm, currentFilter);
  });

  // Filter buttons
  filterButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      // Update active state
      filterButtons.forEach(b => b.classList.remove('active'));
      e.target.classList.add('active');
      
      currentFilter = e.target.dataset.filter;
      const searchTerm = searchInput.value.toLowerCase();
      filterAndRender(searchTerm, currentFilter);
    });
  });
}

// Filter and render vehicles
function filterAndRender(searchTerm, category) {
  let filtered = compatibleVehicles;

  // Apply category filter
  if (category !== 'all') {
    filtered = filtered.filter(v => v.category === category);
  }

  // Apply search filter
  if (searchTerm) {
    filtered = filtered.filter(v => 
      v.make.toLowerCase().includes(searchTerm) || 
      v.model.toLowerCase().includes(searchTerm)
    );
  }

  renderVehicleList(filtered);
}

// Add CSS styles
function addStyles() {
  const style = document.createElement('style');
  style.textContent = `
    .compatibility-checker {
      background: #f9f9f9;
      padding: 30px;
      border-radius: 8px;
      margin: 20px 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    }

    .compatibility-checker h3 {
      margin-top: 0;
      color: #333;
      font-size: 24px;
    }

    .compatibility-subtitle {
      color: #666;
      margin-bottom: 20px;
    }

    .search-box {
      margin-bottom: 20px;
    }

    #vehicle-search {
      width: 100%;
      padding: 12px 16px;
      font-size: 16px;
      border: 2px solid #ddd;
      border-radius: 6px;
      box-sizing: border-box;
      transition: border-color 0.3s;
    }

    #vehicle-search:focus {
      outline: none;
      border-color: #4CAF50;
    }

    .filter-buttons {
      display: flex;
      gap: 10px;
      margin-bottom: 20px;
      flex-wrap: wrap;
    }

    .filter-btn {
      padding: 8px 16px;
      background: white;
      border: 2px solid #ddd;
      border-radius: 20px;
      cursor: pointer;
      font-size: 14px;
      transition: all 0.3s;
    }

    .filter-btn:hover {
      border-color: #4CAF50;
    }

    .filter-btn.active {
      background: #4CAF50;
      color: white;
      border-color: #4CAF50;
    }

    .vehicle-list {
      display: grid;
      gap: 10px;
      margin-bottom: 20px;
    }

    .vehicle-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: white;
      padding: 16px;
      border-radius: 6px;
      border: 1px solid #e0e0e0;
      transition: transform 0.2s, box-shadow 0.2s;
    }

    .vehicle-item:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }

    .vehicle-info {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .vehicle-category {
      color: #666;
      font-size: 13px;
    }

    .hitch-badge {
      display: flex;
      align-items: center;
      gap: 6px;
      background: #e8f5e9;
      color: #2e7d32;
      padding: 6px 12px;
      border-radius: 20px;
      font-weight: 600;
      font-size: 14px;
    }

    .checkmark {
      font-size: 16px;
    }

    .compatibility-note {
      background: #fff3cd;
      padding: 12px;
      border-radius: 6px;
      border-left: 4px solid #ffc107;
      font-size: 14px;
      color: #856404;
    }

    .no-results {
      text-align: center;
      padding: 40px;
      color: #666;
    }

    @media (max-width: 768px) {
      .compatibility-checker {
        padding: 20px;
      }

      .vehicle-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }
    }
  `;
  document.head.appendChild(style);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCompatibilityChecker);
} else {
  initCompatibilityChecker();
}